import { createSlice } from '@reduxjs/toolkit'

export const kidsManagerSlice = createSlice({
  name: 'kidsManager',
  initialState: {
    school: [],
    carnet: [],
    kids: [],
    kidsOptions: [],
    recordData: [],
    addKidModal: false,
    alertModal: false,
    infoModal: false,
    statusModal: false,
    updateModal: false,
    action: '',
    selectedKid: {},

    showRechargeMethods: false,
    recharge_methods: [],
    selectedMethod: '',

    bankOptions: [],
    accountOptions: [
      { label: 'PRINCIPAL', value: 'PRINCIPAL' },
      { label: 'CORRIENTE', value: 'CORRIENTE' },
      { label: 'AHORRO', value: 'AHORRO' }
    ],
    creditOptions: [
      { label: 'Débito', value: 'DEBIT' },
      { label: 'Credito', value: 'CREDIT' }
    ],
    bankTransferOptions: [
      { value: 'mi_banco', label: 'Mi Banco' },
      { value: 'banco_del_tesoro', label: 'Banco del Tesoro' },
      { value: 'bancrecer', label: 'Bancrecer' },
      { value: 'banfanb', label: 'Banfanb' },
      { value: 'bdv', label: 'Banco de Venezuela' },
      { label: 'bancaribe', label: 'Bancaribe' }
    ],
    mobilePayment: {},
    wiretransfer: {},
    transferInfo: {},
    funds: 0,
    isOtpBDV: false
  },

  reducers: {
    setKidsList: (state, action) => {
      state.kids = action.payload.list
      state.kidsOptions = action.payload.options
    },
    setForm: (state, action) => {
      state.addKidModal = action.payload
    },
    setAlertModal: (state, action) => {
      state.alertModal = action.payload
    },
    setInfoModal: (state, action) => {
      state.infoModal = action.payload
    },
    setStatusModal: (state, action) => {
      state.statusModal = action.payload
    },
    setUpdateModal: (state, action) => {
      state.updateModal = action.payload
    },
    setRecordData: (state, action) => {
      state.recordData = action.payload
    },
    setFormInfo: (state, action) => {
      state.school = action.payload.school
      state.carnet = action.payload.carnet
    },
    setRechargeMethods: (state, action) => {
      state.recharge_methods = action.payload
    },
    setSelectedMethod: (state, action) => {
      state.selectedMethod = action.payload
    },
    setRechargeMethodsModal: (state, action) => {
      state.showRechargeMethods = action.payload
    },
    setBankOptions: (state, action) => {
      state.bankOptions = action.payload
    },
    setMobilePayment: (state, action) => {
      state.mobilePayment = action.payload[0]
    },
    setWiretransfer: (state, action) => {
      state.wiretransfer = action.payload[0]
    },
    setTransferInfo: (state, action) => {
      state.transferInfo = action.payload
    },
    setFunds: (state, action) => {
      state.funds = action.payload
    },
    setTypeOtp: (state, action) => {
      state.isOtpBDV = action.payload
    },
    setAction: (state, action) => {
      state.action = action.payload
    },
    setSelectedKid: (state, action) => {
      state.selectedKid = action.payload
    }
  }
})

export const {
  setKidsList,
  setForm,
  setAlertModal,
  setInfoModal,
  setRecordData,
  setFormInfo,
  setRechargeMethods,
  setSelectedMethod,
  setRechargeMethodsModal,
  setBankOptions,
  setMobilePayment,
  setWiretransfer,
  accountOptions,
  setTransferInfo,
  setFunds,
  setTypeOtp,
  setStatusModal,
  setUpdateModal,
  setAction, 
  setSelectedKid
} = kidsManagerSlice.actions

export const kidsList = kidsManagerSlice.reducer
